import { useEffect, useState } from 'react';

export const SETUP_TOUR_REQUIRED_FIELDS_EVENT = 'setup-tour:required-fields';

type RequiredFieldsPromptDetail = { target: string };

export const requestTourRequiredFields = (target: string): void => {
  window.dispatchEvent(
    new CustomEvent<RequiredFieldsPromptDetail>(SETUP_TOUR_REQUIRED_FIELDS_EVENT, {
      detail: { target },
    }),
  );
};

export const useTourRequiredFieldsPrompt = (target?: string): number => {
  const [sequence, setSequence] = useState(0);

  useEffect(() => {
    if (!target) return;
    const handlePrompt = (event: Event): void => {
      const detail = (event as CustomEvent<RequiredFieldsPromptDetail>).detail;
      if (detail.target === target) setSequence((current) => current + 1);
    };
    window.addEventListener(SETUP_TOUR_REQUIRED_FIELDS_EVENT, handlePrompt);
    return () => {
      window.removeEventListener(SETUP_TOUR_REQUIRED_FIELDS_EVENT, handlePrompt);
    };
  }, [target]);

  return sequence;
};
